export enum FeaturesEnums {
  EmployeeProfileScreen = 28001,
  EmployeeProfileAbsences = 28002,
  EmployeeProfileCorpAddress = 28003,
  EmployeeProfileCorporate = 28004,
  EmployeeProfileFamilyDetails = 28005,
  EmployeeProfileGeneral = 28006,
  EmployeeProfileHRProfile = 28007,
  EmployeeProfilePersonal = 28008,
  EmployeeProfilePrivate = 28009,
  EmployeeProfilePublic = 28010,
  EmployeeProfileQualifications = 28011,
  EmployeeProfileRates = 28012,
  EmployeeProfileNotes = 28013,
  EmployeeProfileWorkrule = 28032,
  EmployeeProfileTraining = 28054,
  EmployeeProfilePremiums = 28094,
  EmployeeProfileDocuments = 28109,

  Reports = 28020,
  SystemPrompts = 28023, //DisplayLabels
  TimeCardEditor = 28024, // Time Card Editor
  Jobs = 28027, // Jobs Editor
  LaborLevels = 28055, // Jobs Data Editor
  GlobalRecalculation = 28037,
  AccrualSummary = 28047,
  AccrualBalanceDetails = 28048,
  TimesheetSignoff = 28061, // Time Card Editor
  Schedule_Employee_Absences = 28067,
  PeriodSignoff = 28077,
  WebPunchFeature = 28080,
  Notifications = 29991,
  Scheduling_Function = 29993,
  JobCosting = 29995, // Time Card Editor
  DepartmentAllocation = 29996, // Time Card Editor
  ApproveCostingTrans = 29104,
  EmployeeLoaning = 29105,
  Rates = 29992,
  AccrualsFunction = 29997,
  SchedulingLabourAllocation = 28081, // Scheduler with Labour Allocation
  //LabourRequirements = 28082,
  AdminPage = 28083,
  //JobScheduler = 28084,
  Departments = 28026, // Department Editor
  TimeCategoryGroups = 28058,
  ExceptionGroups = 28035,
  BadgeEditor = 28016,
  DayTypes = 28017,
  Qualifications = 28014,
  SystemSettings = 28031,
  QualificationAssignments = 28057,
  QuerySearchSelect = 28045,
  Holidays = 28028,
  Terminals = 28033,
  ConfigurationPage = 28086,
  PunchDefinitions = 28025,
  PunchErrors = 28029,
  EmployeeMaintenance = 28051,
  TimeCategories = 28019,
  Visibility = 28039,
  SubmitTransactionFile = 28030,
  Timesheet = 28087,
  PolicySetupScreen = 29806,
  StatBonusRule = 28038,
  AccrualDefinitions = 28046,
  WorkRuleDefinitions = 28015,
  PeriodSelection = 28036,
  PayrollExport = 28042,
  TimeAndAttendanceReportGroup = 29801,
  RolesAndPermissions = 29810,
  UsersAndRoles = 29811,
  FeaturesAndPermissions = 29812,
  UserManagement = 28092,
  LettersModule = 28088,
  FeatureLettersConfiguration = 28089,
  SecurityPage = 28090,
  EmployeeExport = 28034,
  PunchExport = 28044,
  TransactionExport = 28056,
  ClockPoll = 28060,
  VisualPatternTracker = 28043,
  RecordLockMgmt = 28093,
  SysInfo = 28095,
  EmployeeDepartmentRate = 28096,
  EmployeeJobRates = 28097,
  MassEdits = 28098,
  SchedulingAvailability = 28099,
  TAReportsWithWages = 29803, // Time and Attendance Reports With Wages
  DepartmentPremiums = 28100,
  OverridePaidEndShifts = 28101,
  DepartmentWRFilter = 28102,
  ReportManagement = 28103,
  DepartmentTCFilter = 28062,
  Dashboard = 28059,
  EmployeeTimecardStatus = 28091,
  AutoPollingFunction = 29994,
  AbsenceRequest = 28052,
  DepartmentNotifications = 28053,
  ExpressImplementationPortal = 28063,
  UserTraining = 29998,
  EmployeeCalendar = 28104,
  ViewPayStubs = 28105,
  TaskQ = 28106,
  IntegrationPartner = 28108,
  CompanyDirectory = 28110,
  ErrorsExceptions = 28111,
  ApplicationEvents = 28112,
  ESSTimecard = 28113,
  PunchRestrictions = 28114,
  SchedulingBudgetDataEntry = 28115,
  SchedulingBudget = 28116,
  ShiftSwapping = 28117,
  ScheduleCoverage = 29999,
  RetailSchedulerConfig = 28119,
  MobilePunchFeature = 28120,
}
